import type { ReactElement } from 'react'
import { CaseInfrastructureTabModals } from './CaseInfrastructureTabModals'
import { mapStateToModalProps } from './case-infrastructure-modals.props'
import type { CaseInfrastructureTabState } from './use-case-infrastructure-tab'

export function CaseInfrastructureModalsSection({
  state,
}: {
  state: CaseInfrastructureTabState
}): ReactElement {
  return <CaseInfrastructureTabModals {...mapStateToModalProps(state)} />
}
